import { z } from "zod";
import { TimeSlot } from "@carry/shared";
import { PublicIdSchema } from "./common";

export const InstructionStatusItem = z.object({
  route_id: PublicIdSchema,
  route_number: z.number().int().min(1),
  // #425: レーンは日単位。代表便 (最初に到達する便) の導出値で、導出不能時は null。
  time_slot: TimeSlot.nullable(),
  driver: z.object({
    id: PublicIdSchema,
    name: z.string(),
  }),
  is_read: z.boolean(),
  read_at: z.iso.datetime({ offset: true }).nullable(),
  total_deliveries: z.number().int().min(0),
});

export const MarkInstructionReadResult = z.object({
  route_id: PublicIdSchema,
  read_at: z.iso.datetime({ offset: true }),
});

export const ListInstructionStatusInput = z.object({
  plan_date: z.iso.date(),
});

export type InstructionStatusItemDto = z.infer<typeof InstructionStatusItem>;
export type MarkInstructionReadResultDto = z.infer<typeof MarkInstructionReadResult>;
